import { create } from 'zustand'

const createMainSlice = (set, get) => ({
  step: 1,
  rooms: [{
    id: 0,
    people: [{
      id: 0,
      type: 'adult',
      name: '1 взрослый',
      guest_id: 1,
      program: { id: null, name: null },
      program_type: { id: null, name: null },
      program_length: null,
      program_price: null,
      program_discount: 0,
      program_discount_sum: 0,
      program_discount_text: '',
      express: null,
      expressCount: null
    }],
    apartment: null,
    apartmentName: null,
    price: 0,
  }],
  roomVariants: null,
  arrivalDate: null,
  increaseStep: () => set((state) => ({ step: state.step + 1 })),
  decreaseStep: () => set((state) => ({ step: state.step - 1 })),
  setExpress: (roomId, guestId, express) => set((state) => {
    const stateRooms = [...state.rooms];
    const room = stateRooms.find(room => room.id === roomId);
    room.people[guestId].express = express;
    return { rooms: [...stateRooms] }
  }),
  setExpressCount: (roomId, guestId, expressCount) => set((state) => {
    const stateRooms = [...state.rooms];
    const room = stateRooms.find(room => room.id === roomId);
    room.people[guestId].expressCount = expressCount;
    return { rooms: [...stateRooms] }
  }),
  updatePrice: (roomId, guestId, priceInfo) => set((state) => {
    const stateRooms = [...state.rooms];
    const room = stateRooms.find(room => room.id === roomId);
    const guest = room.people[guestId];

    if (typeof priceInfo === 'number') {
      guest.program_price = priceInfo;
      guest.program_discount = 0;
      guest.program_discount_sum = 0;
      guest.program_discount_text = '';
    } else {
      guest.program_price = priceInfo.program_price;
      guest.program_discount = priceInfo.program_discount ?? 0;
      guest.program_discount_sum = priceInfo.program_discount_sum ?? 0;
      guest.program_discount_text = priceInfo.program_discount_text ?? '';
    }

    return { rooms: [...stateRooms] }
  }),
  updateRoom: (roomId, updates) => set((state) => {
    const updatedRooms = state.rooms.map(room =>
      room.id === roomId ? { ...room, ...updates } : room
    );
    return { rooms: updatedRooms };
  }),
  setArrivalDate: (date) => set((state) => ({ arrivalDate: date })),
  addRoom: () => set((state) => ({
    rooms: [...state.rooms, {
      id: state.rooms.length,
      people: [{
        id: 0,
        type: 'adult',
        name: `1 взрослый`,
        guest_id: 1,
        program: { id: null, name: null },
        program_type: { id: null, name: null },
        program_length: null,
        express: null,
      }],
      apartment: null,
      apartmentName: null,
      price: 0,
    }]
  })),
  setRoomVariants: (data) => set((state) => state.roomVariants = { ...data }),
  updateRoomApartment: (roomId, appartmentId) => set((state) => {
    const stateRooms = [...state.rooms];
    const room = stateRooms.find(room => room.id === roomId);
    room.apartment = appartmentId;
    return { rooms: [...stateRooms] }
  }),
  updateRoomAdults: (roomId, adultCount) => set((state) => {
    const stateRooms = [...state.rooms];
    const room = stateRooms.find(room => room.id === roomId);
    room.people = Array.from({ length: adultCount }, (_, id) => ({
      id,
      type: 'adult',
      guest_id: adultCount,
      name: `${id + 1} взрослый`,
      program: { id: null, name: null },
      program_type: { id: null, name: null },
      program_length: null,
      express: null,
    }));

    return { rooms: [...stateRooms] }
  }),
  addChildToRoom: (roomId, childId, childName, guest_id) => set((state) => {
    const stateRooms = [...state.rooms];
    const room = stateRooms.find(room => room.id === roomId);
    if (childId === null) {
      room.people.push({
        id: room.people.length,
        type: 'child',
        name: childName,
        guest_id,
        program: { id: null, name: null },
        program_type: { id: null, name: null },
        program_length: null,
      })

      room.people = room.people.map((item, idx) => ({ ...item, id: idx }))
    } else {
      room.people.find((item) => item.id === childId).name = childName;
      room.people.find((item) => item.id === childId).guest_id = guest_id;
    }
    return { rooms: [...stateRooms] }
  }),
  removeChildFromRoom: (roomId, childId) => set((state) => {
    const stateRooms = [...state.rooms];
    const room = stateRooms.find(room => room.id === roomId);
    room.people = room.people.filter((item) => item.id !== childId).map((item, idx) => ({ ...item, id: idx }));
    return { rooms: [...stateRooms] }
  }),
  removeRoom: () => set((state) => {
    return { rooms: [...state.rooms.slice(0, -1)] }
  }),
  updateGuest: (roomId, id, programData) => set((state) => {
    const stateRooms = [...state.rooms];
    const room = stateRooms.find(room => room.id === roomId);
    room.people[id] = { ...room.people[id], ...programData }
    return { rooms: [...stateRooms] }
  }),

  canBookRooms: () => {
    const state = get();
    const allGuests = state.rooms.flatMap(room => 
      room.people.map(guest => ({ ...guest, roomId: room.id }))
    );
  
    const expressGuests = allGuests.filter(guest => guest.express !== null);
  
    if (expressGuests.length === 0) return false;
  
    const expressToRooms = {};
    expressGuests.forEach(guest => {
      if (!expressToRooms[guest.express]) {
        expressToRooms[guest.express] = new Set();
      }
      expressToRooms[guest.express].add(guest.roomId);
    });
  
    return expressGuests.every(guest => {
      if (guest.express === null || guest.expressCount === null) return false;
      const roomCount = expressToRooms[guest.express].size;
      return roomCount <= guest.expressCount;
    });
  },
});

const createActiveRoomSlice = (set) => ({
  activeRoom: null,
  activeGuest: null,
  setActiveRoom: (roomId) => set(() => ({ activeRoom: roomId })),
  setActiveGuest: (guestId) => set(() => ({ activeGuest: guestId })),
});

const useStore = create((...a) => ({
  ...createMainSlice(...a),
  ...createActiveRoomSlice(...a),
}))

export default useStore;